import React, { forwardRef } from 'react';
import { gql } from '@apollo/client';
import { TikTokSettingsController, TikTokSettingsControllerProps } from './TikTokSettings.controller';

export type TikTikSettingsApolloProps = {
  //
  checked: TikTokSettingsControllerProps['checked'];
  disabled: TikTokSettingsControllerProps['disabled'];
  expanded: TikTokSettingsControllerProps['expanded'];
  profileId: TikTokSettingsControllerProps['profileId'];
  setExpanded: TikTokSettingsControllerProps['setExpanded'];
  tikTokActionRules: TikTokSettingsControllerProps['tikTokActionRules'];
  tikTokActionValue: TikTokSettingsControllerProps['tikTokActionValue'];
  tikTokFormName: TikTokSettingsControllerProps['tikTokFormName'];
  tikTokPromotionRules: TikTokSettingsControllerProps['tikTokPromotionRules'];
  tikTokPromotionValue: TikTokSettingsControllerProps['tikTokPromotionValue'];
  tikTokSettings: TikTokSettingsControllerProps['tikTokSettings'];
  tikTokTargetRules: TikTokSettingsControllerProps['tikTokTargetRules'];
  tikTokTargetValue: TikTokSettingsControllerProps['tikTokTargetValue'];
  useFormInstance: TikTokSettingsControllerProps['useFormInstance'];
  dropdownRef?: TikTokSettingsControllerProps['dropdownRef'];
  isParentDropdownExpanded: TikTokSettingsControllerProps['isParentDropdownExpanded'];
};

gql`
  mutation RefreshTikTokSocialProfileSettings($id: ID!) {
    refreshTikTokSocialProfileSettings(socialProfileId: $id) {
      ...CoreSocialProfileFields
      ...CoreTikTokProfileFields
    }
  }
`;

export const TikTokSettingsApollo = forwardRef<HTMLDivElement | null, TikTikSettingsApolloProps>(
  (props, ref): JSX.Element => {
    return <TikTokSettingsController {...props} ref={ref} />;
  }
);

TikTokSettingsApollo.displayName = 'TikTokSettingsApollo';
